/**
 * DIE KENNZAHLOPTIONEN EINES BERICHTS (ÄA-53, Auftrag CRM-88) — was Maske und
 * Server gleich sagen muessen.
 *
 * OHNE EINFUHR, wie `achsen.ts`: Die Oberflaeche fuehrt diese Datei ueber
 * ihren Quellpfad ein (`@crm/kontrakte/src/kennzahloptionen`), die API ueber
 * das Paket. Der Grund einer Sperre steht so im Baukasten mit demselben
 * Wortlaut wie in der Abweisung des Servers.
 */

/** AUS-33: Ohne zeitliche Gruppierung gibt es keine laufende Summe. */
export const OHNE_ZEITACHSE =
  'Kumuliert wird entlang einer Zeitachse — gruppieren Sie nach Tag, Woche, Monat, Quartal oder Jahr.';

/** AUS-31: Die Quartile stehen nur neben dem Median. */
export const QUARTILE_NUR_MIT_MEDIAN = 'Die Quartile stehen nur zusammen mit dem Median.';
